<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div id="widget-container" class="vx-row">
      <div v-show="$acl.check('ReviewVideos')" id="videoReviewCard-container" class="vx-col w-1/2 mb-base">
        <!-- <div class="vx-col w-full md:w-1/2 mb-base"> -->
        <vx-card
          id="videoReviewCard"
          ref="videoReviewCard"
          title="Videos To Review"
          title-color="#000"
          content-color="#f00"
          card-background="linear-gradient(to right, #cccccc 0%,#dddddd 100%)"
          class="vs-con-loading__container"
        >
          <div slot="no-body" class="mt-4">
            <vs-table
              id="videosTable"
              stripe
              single
              :data="videos"
              v-model="selectedvideo"
              @selected="handleSelectedVideo"
              ref="videosTable"
              class="vs-con-loading__container cursor-default"
            >
              <div slot="header">
                <div class="ml-4 mb-2">
                  <p-check class="ml-2 p-default p-curve p-fill p-icon p-smooth" v-model="showAll" color="success">
                    <i class="icon feather icon-check" slot="extra"></i>
                    Show All
                  </p-check>
                </div>
              </div>

              <template slot-scope="{data}">
                <vs-tr
                  :data="video"
                  :key="indextr"
                  v-for="(video, indextr) in data"
                >
                  <vs-td :data="data[indextr].name">{{ video.name }}</vs-td>

                  <vs-td :data="data[indextr].description">{{ video.description }}</vs-td>

                  <vs-td
                    :data="data[indextr].modifiedOn"
                  >{{ video.modifiedOn.replace("T", " ").split('.')[0] }}</vs-td>

                  <vs-td>
                    <vs-chip
                      v-show="video.videoStatusId"
                      :color="getStatusColor(video.videoStatusId)"
                    >{{ video.status }}</vs-chip>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videos: [],
      showAll: false,
      selectedvideo: []
    };
  },
  components: {},
  watch: {
    showAll: function(val) {
      this.loadVideos(val);
    }
  },
  methods: {
    handleSelectedVideo(video) {
      var self = this;

      self.$router.push({ name: 'MediaPreviewer', query: { videoId: video.id, m: "rev" } });
    },
    loadVideos(val) {
      const self = this;
      self.showLoadingOnElement("videoReviewCard", 0.75, "corners");

      var onSuccess = function(response) {
        self.videos = response.data;
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.videoReviewCard.$el);
      };

      self.$ajaxGet(
        self,
        "video/ListVideosToReview?showAll=" + val,
        onSuccess,
        onFinally
      );
    },
    getStatusColor(statusId) {
      var self = this;
      if (statusId == 1) return "warning";
      else if (statusId == 2) return "success";
      else if (statusId == 3) return "success";
      else if (statusId == 4) return "danger";
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    }
  },
  mounted() {
    if(this.$acl.check('ReviewVideos'))
      this.loadVideos(false);
    this.$setColors()
  },
  created() {
    if(!localStorage.getItem("userInfo") || !localStorage.getItem("accessToken")) {
      window.location.replace("/login");
    }

    if(localStorage.getItem("isStudent") == "true") {
      window.location.replace("/login");
    }
  },
  beforeCreate() {
    if (this.$acl.not.check("ViewDashboard")) {
      let routeData = this.$router.resolve({ name: 'page-not-authorized' });
      window.open(routeData.href, '_self');
    }
  }
};
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }

  @media screen and (max-width: 900px) {
    #widget-container {
      display: block !important;

      #videoReviewCard-container {
        width: 100% !important;
      }

      #leadsCard-container {
        margin-top: 20px;
        width: 100% !important;
      }
    }
  }

  .vs-con-table .vs-con-tbody {
    background: none !important;
    border: 0px solid #f8f8f8 !important;
  }
}
</style>
